/* istanbul ignore file */
import { array as codecArray, number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { IOTestOption } from './IOTestOption';
const IOTestInputCaseParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['weight', codecNumber],
    ['args', codecString],
    ['stdin', codecString],
    ['output', codecString],
    ['options', /* #__PURE__ */ codecArray(IOTestOption)],
]));
export class IOTestInputCase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return IOTestInputCaseParser.decode(input).map(res => new IOTestInputCase(res));
    }
    static unsafeDecode(input) {
        return IOTestInputCase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IOTestInputCaseParser.encode(data);
    }
    static schema() {
        return IOTestInputCaseParser.schema();
    }
}
